import { MARK_AS_READ, UPDATE_MESSAGE_MAPS } from '../actions';

const defaultState = {};

export function ocMessage(state = defaultState, action = null) {
  switch (action.type) {
    case UPDATE_MESSAGE_MAPS: {
      return {
        ...state,
        [action.channelId]: {
          followerMessageMap: action.followerMessageMap,
          followerAlertMap: action.followerAlertMap,
        },
      };
    }
    case MARK_AS_READ: {
      return {
        ...state,
        [action.channelId]: {
          ...state[action.channelId],
          followerAlertMap: {
            ...state[action.channelId].followerAlertMap,
            [action.followerId]: false,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/ocMessage.js